const modalMap = new Map();

/* OPEN MODAL */
document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.modal-trigger');
    if (!trigger) return;

    const id = trigger.getAttribute('aria-controls');
    const dialog = document.getElementById(id);
    if (!dialog) return;

    dialog.showModal();
    trigger.setAttribute('aria-expanded', 'true');

    modalMap.set(dialog, trigger);
});

/* CLOSE BUTTON */
document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.modal-close');
    if (!closeBtn) return;

    const dialog = closeBtn.closest('dialog');
    if (dialog) dialog.close();
});

/* CLICK OUTSIDE (BACKDROP) */
document.addEventListener('click', (e) => {
    const dialog = e.target;

    // only if user clicked directly on the dialog backdrop
    if (dialog instanceof HTMLDialogElement && e.target === dialog) {
        dialog.close();
    }
});

/* CLOSE ON IN-PAGE ANCHOR */
document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const dialog = link.closest('dialog');
    if (dialog) dialog.close();
});

/* CLEANUP ON CLOSE */
document.addEventListener('close', (e) => {
    const dialog = e.target;
    if (!(dialog instanceof HTMLDialogElement)) return;

    const trigger = modalMap.get(dialog);

    if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
        modalMap.delete(dialog);
    }
}, true);
